export enum ModalEvent {
  onClose = 'onClose',
}
